import { trpc } from "../trpc";

export const usePaymentMethods = () => {
  const { data } = trpc.account.paymentSources.useQuery();

  return {
    hasPaymentSource: !!data?.hasPaymentSource,
  };
};
